import React from 'react';
import { makeStyles, createStyles } from '@material-ui/styles';
import { FormSubmissionDetail, FormFieldConfig } from './form-responses-types';
import { formatSubmissionDate, sortFieldValuesByFormOrder } from './form-responses-utils';

const useStyles = makeStyles(
  createStyles({
    printContainer: {
      padding: '32px',
      backgroundColor: '#fff',
      '& .print-header': {
        marginBottom: '24px',
        paddingBottom: '16px',
        borderBottom: '2px solid #333',
      },
      '& .print-title': {
        fontSize: '24px',
        fontWeight: 700,
        color: '#333',
        marginBottom: '8px',
      },
      '& .print-subtitle': {
        fontSize: '14px',
        color: '#666',
      },
      '& .print-field': {
        padding: '12px 0',
        borderBottom: '1px solid #eee',
      },
      '& .print-field-label': {
        fontSize: '12px',
        fontWeight: 600,
        color: '#666',
        marginBottom: '4px',
      },
      '& .print-field-value': {
        fontSize: '14px',
        color: '#333',
      },
      '& .print-meta': {
        marginTop: '24px',
        paddingTop: '16px',
        borderTop: '1px solid #ddd',
        fontSize: '11px',
        color: '#999',
      },
    },
  })
);

interface PrintContentProps {
  printRef: React.RefObject<HTMLDivElement>;
  formTitle: string;
  selectedSubmission: FormSubmissionDetail | null;
  currentResponseNumber: number;
  totalSubmissions: number;
  formFields: FormFieldConfig[];
}

export const PrintContent: React.FC<PrintContentProps> = ({
  printRef,
  formTitle,
  selectedSubmission,
  currentResponseNumber,
  totalSubmissions,
  formFields,
}) => {
  const classes = useStyles();

  return (
    <div style={{ display: 'none' }}>
      <div ref={printRef} className={classes.printContainer}>
        {selectedSubmission && (
          <>
            <div className='print-header'>
              <div className='print-title'>{formTitle}</div>
              <div className='print-subtitle'>
                Response {currentResponseNumber} of {totalSubmissions} |{' '}
                {formatSubmissionDate(selectedSubmission.submissionDate)}
              </div>
            </div>
            <div>
              {selectedSubmission.formFieldValues && selectedSubmission.formFieldValues.length > 0 ? (
                sortFieldValuesByFormOrder(selectedSubmission.formFieldValues, formFields).map((fieldValue) => (
                  <div key={fieldValue.formFieldValueId} className='print-field'>
                    <div className='print-field-label'>{fieldValue.fieldName}</div>
                    <div className='print-field-value'>{fieldValue.value || '-'}</div>
                  </div>
                ))
              ) : (
                <div className='print-field-value'>No field values</div>
              )}
            </div>
            <div className='print-meta'>
              IP: {selectedSubmission.ipAddress || '-'} | User Agent: {selectedSubmission.userAgent || '-'} | Referrer:{' '}
              {selectedSubmission.referrer || '-'}
            </div>
          </>
        )}
      </div>
    </div>
  );
};
